export default class extends Controller {
  static targets = ['popoverContainer']

  connect() {
    this.hidePopover()
    this.hideIfClickedOutside = this.hideIfClickedOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.hideIfClickedOutside)
  }

  hideIfClickedOutside(event) {
    if (!(this.element.contains(event.target) || this.element == event.target)) {
      this.hidePopover()
    }
  }

  togglePopover() {
    this.isOpen = !this.isOpen;
  }

  hidePopover() {
    this.isOpen = false;
  }

  get isOpen() {
    return !this.popoverContainerTarget.classList.contains("hidden")
  }

  set isOpen(val) {
    this.popoverContainerTarget.classList[val ? "remove" : "add"]("hidden");
    document[`${val ? "add" : "remove"}EventListener`]('click', this.hideIfClickedOutside.bind(this))
  }
}



// WEBPACK FOOTER //
// ./app/components/popups/assets/javascript/popups-activity-alert-link-controller.js